import { CircularProgress, Grid } from '@mui/material';
import React from 'react';

const SuspenseLoader = () => (
  <Grid container justifyContent="center" alignItems="center" sx={{ margin: 'auto', height: '80vh' }}>
    <CircularProgress />
  </Grid>
);

export default SuspenseLoader;
